import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { authService } from '../services/authService';
import { usersService } from '../services/usersService';
import { itemsService } from '../services/itemsService';
import { scrappersService } from '../services/scrappersService';
import { comparisonService } from '../services/comparisonService';
import { exportService } from '../services/exportService';
import { dashboardService } from '../services/dashboardService';

export const useApi = () => {
  const { token } = useAuth();
  return useMemo(
    () => ({
      auth: authService(token),
      users: usersService(token),
      items: itemsService(token),
      scrappers: scrappersService(token),
      comparison: comparisonService(token),
      export: exportService(token),
      dashboard: dashboardService(token),
    }),
    [token]
  );
};
